// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"bfed37b1","406":"fa9de50b","449":"9545b0c5","453":"4b720780","578":"c8ed6799","743":"24fb22a8","819":"5fa93b80","829":"489ed7e5","831":"d9466d22"}[chunkId] + ".chunk.js";
};